import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const poll = {
  createPoll: lazyModuleMethod(() => import('./createPoll'), 'default'),
  createPollChoice: lazyModuleMethod(
    () => import('./createPollChoice'),
    'default'
  ),
  deletePoll: lazyModuleMethod(() => import('./deletePoll'), 'default'),
  deletePollChoice: lazyModuleMethod(
    () => import('./deletePollChoice'),
    'default'
  ),
  editPoll: lazyModuleMethod(() => import('./editPoll'), 'default'),
  fetchPoll: lazyModuleMethod(() => import('./fetchPoll'), 'default'),
  fetchPollChoice: lazyModuleMethod(
    () => import('./fetchPollChoice'),
    'default'
  ),
  generateVotePollChoice: lazyModuleMethod(
    () => import('./generateVotePollChoice'),
    'default'
  ),
  fetchPollChoices: lazyModuleMethod(
    () => import('./fetchPollChoices'),
    'default'
  ),
  fetchPolls: lazyModuleMethod(() => import('./fetchPolls'), 'default'),
  updatePollChoice: lazyModuleMethod(
    () => import('./updatePollChoice'),
    'default'
  ),
  updatePollMass: lazyModuleMethod(() => import('./updatePollMass'), 'default'),
}
